import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router';
import get from 'lodash/get';

import { upgradeMembership } from 'actions/stripeSubscriptionActions';
import { updateUpsellData } from 'actions/userActions';
import Loading from 'components/Loading/Loading';
import './style.css';

class SpecialOffer extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isSubmitting: false,
      submitError: null,
    };
  }

  handleSubmit = () => {
    const { user, upgradeMembership } = this.props;
    const upsellPlan = get(user, 'upsellData.upsellPlan');
    const subscriptionId = user.profile.live_subscription.id;
    this.setState({ isSubmitting: true });
    upgradeMembership(subscriptionId, null, upsellPlan.id, null, () => {
      this.resetUpsellData();
    }, error => {
      const submitError = get(error, 'message', 'Something went wrong');
      this.setState({ submitError, isSubmitting: false });
    });
  }

  handleSkip = (event) => {
    event.preventDefault();
    this.resetUpsellData();
  }

  resetUpsellData = () => {
    this.props.updateUpsellData({ upsellPlan: null });
  }

  render() {
    const { isSubmitting, submitError } = this.state;
    const { profile, upsellData } = this.props.user;
    const currentPlan = profile.stripePlan;
    const upsellPlan = upsellData.upsellPlan;

    if (!currentPlan || !upsellPlan) {
      return null;
    }

    const currentPrice = currentPlan.price.month - 0.01;
    const newPrice = upsellPlan.price.month;
    const savedPrice = Math.ceil((currentPrice - newPrice) * 12);

    return (
      <div className="special-offer mx-auto p-5 px-sm-5 pt-sm-5">
        <div className="px-0 px-sm-4">
          <div className="special-offer__header">
            <h6 className="special-offer__header-title mb-4">
              Special offer!
            </h6>
            <h1 className="special-offer__header-save-title mb-3">
              Save ${savedPrice}/year
            </h1>
            <div className="special-offer__description text-center">
              Switch to our 6 months program, and pay just
            </div>
            <div className="special-offer__subheader text-center">
              <span className="special-offer__subheader-origin">${currentPrice}/mo</span>
            &nbsp;&nbsp;
            <span className="special-offer__subheader-sale">${newPrice}/mo</span>
            </div>
          </div>

          <hr />
          <div className="special-offer__price my-4 text-center">
            <div className="m-0">
              Current: <span className="special-offer__price-current">${currentPrice}/mo ({currentPlan.limit} hours paid monthly)</span>
            </div>
            <div className="mt-2"><b>New: ${newPrice}/mo ({upsellPlan.limit} hours prepaid 6 months)</b></div>
          </div>
          <hr />

          <div className="special-offer__terms">
            <p className="m-0">
              By selecting "Yes, I want to save", I understand my subscription<br />
              will be switched to Rype's {upsellPlan.limit} hours prepaid 6 months plan.
            </p>
            {submitError && <p className="text-danger my-2">{submitError}</p>}
            {isSubmitting ? (
              <div className="text-center mt-4">
                <Loading size="small" />
              </div>
            ) : (
                <Fragment>
                  <button
                    type="button"
                    className="btn btn-primary btn-submit btn-cursor m-4 py-3"
                    onClick={this.handleSubmit}
                  >
                    Yes, I want to save.
                </button>
                  <div className="text-center">
                    <Link className="custom-link" to="#" onClick={this.handleSkip}>
                      Not right now
                  </Link>
                  </div>
                </Fragment>
              )}
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    user: state.user,
  };
}
export default connect(mapStateToProps, { upgradeMembership, updateUpsellData })(SpecialOffer);



// WEBPACK FOOTER //
// ./src/pages/student/SpecialOffer/index.js